import { useEffect, useState } from "react";
import Fade from "../components/Fade";
import LogoFooter from "../components/LogoFooter";

export default function Agradecimento() {
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    if (counter <= 0) {
      window.location.href = process.env.REACT_APP_ROOT_FOLDER || "/";
      return;
    }

    const timeoutId = setTimeout(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [counter]);

  return (
    <>
      <Fade>
        <div className="w-full min-h-screen flex flex-col justify-between px-12 pt-8 pb-4">
          <div className="grid content-center flex-1 grid-rows-[max-content_max-content_max-content] py-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 214 214"
              className="check-circle mx-auto"
            >
              <g fill="none" stroke="currentColor" strokeWidth="2">
                <circle
                  fill="currentColor"
                  opacity="0.15"
                  cx="107"
                  cy="107"
                  r="72"
                />
                <circle
                  className="colored"
                  fill="currentColor"
                  cx="107"
                  cy="107"
                  r="72"
                  opacity="0.8"
                />
                <polyline
                  stroke="#fff"
                  strokeWidth="10"
                  points="73.5,107.8 93.7,127.9 142.2,79.4"
                  style={{
                    strokeDasharray: "50%, 50%",
                    strokeDashoffset: "100%",
                  }}
                />
              </g>
            </svg>

            <h1 className="text-6xl font-tommy px-20 text-deepBlue text-center">
              <strong>Formulário enviado com sucesso</strong>
            </h1>

            <h2 className="text-center font-tommy text-4xl font-semibold mt-4 text-deepBlue">
              Agradecemos sua colaboração
            </h2>

            <span className="text-center text-2xl mt-5 text-deepBlue">
              Você será redirecionado à tela inicial automaticamente em{" "}
              {counter}s.
            </span>
          </div>

          <div className="w-full p-6 flex items-center justify-end">
            <LogoFooter />
          </div>
        </div>
      </Fade>

      <style>{`
        svg.check-circle {
          color: #389623;
          height: 240px;
          width: 240px;
        }
        @keyframes checkmark { 0% { stroke-dashoffset: 50%; } 100% { stroke-dashoffset: 0px; } }
        svg.check-circle polyline { animation: checkmark 0.5s cubic-bezier(0.55, 0.2, 0.71, -0.04) 0.7s backwards; }
        @keyframes grow-circle { 0% { r: 0; } }
        @keyframes grow-circle-bigger { 50% { opacity: 0.11; } 100% { r: 100; opacity: 0; } }
        svg.check-circle circle.semi-transparent { animation: grow-circle 0.45s cubic-bezier(0.66, 0.23, 0.51, 1.23) backwards, grow-circle-bigger 0.9s linear 1.1s forwards; }
        svg.check-circle circle.colored { animation: grow-circle 0.5s cubic-bezier(0.66, 0.23, 0.51, 1.23) 0.25s backwards; }
      `}</style>
    </>
  );
}
